import { render, staticRenderFns } from "./ToggleRewardsModal.vue?vue&type=template&id=ef1df812&scoped=true&"
import script from "./ToggleRewardsModal.vue?vue&type=script&lang=ts&"
export * from "./ToggleRewardsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleRewardsModal.vue?vue&type=style&index=0&id=ef1df812&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1df812",
  null
  
)

export default component.exports